import { PageType } from "shared/lib/page-type";

import type { AppBarVariant } from "scmp-app/components/app-bar/types";
import type { Variant as SectionVariant } from "scmp-app/pages/section/enums";

export const pathname = "/sub-section";

export const page = {
  route(
    query: QueryParameters<{
      appBarVariant?: AppBarVariant;
      asPath?: string;
      entityId: string;
      name?: string;
      parentSection?: string;
      relatedSectionsQueueName?: string;
      sectionVariant?: SectionVariant;
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: PageType.SubSection },
    };
  },
};
